/* eslint-disable import/first */
import React from 'react';
import { useNavigate, useLocation } from '@reach/router';
import { useIntl, FormattedMessage } from 'react-intl';
import css from './index.module.scss';
import noImg from '../../assets/no-itm.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { getCleanURL, generateProductRoute } from 'spwa-ui-library/esm/utils/path';
import { isProductCustomized } from 'spwa-ui-library/esm/utils/helper';
import { Redux, Slices } from 'spwa-ui-library';

const { useSelector, useDispatch } = Redux;
const { getClusterId } = Slices.configSlice;
const { getProductInfo } = Slices.productSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { selectProductEntities, addNewProduct, fetchProductsByCategoryId } = Slices.productSlice;

const { addProductToCustomize, addPayloadToTempData } = Slices.tempCartSlice;

export default function ProductTileImage({
  imageSrc,
  productObj,
  productRoute,
  productName,
  name,
  children,
  oldLocation,
  isPreviouslyOrdered,
  mainProductId,
  returnURL,
  buildCat,
}) {
  const src = getCleanURL(imageSrc);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const clusterId = useSelector(getClusterId);
  const defaultAddress = useSelector(selectDefaultAddress);
  const categoryList = useSelector((state) => state.category);

  const locationSearch = new URLSearchParams(location.search);

  const tempItems = useSelector((state) => state.tempCart);
  const productsMap = useSelector(selectProductEntities);
  const intl = useIntl();
  const goToCustomize =
    productObj.typeId === 'simple' ||
    (productObj.typeId === 'configurable' && productObj.inSide === 0)
      ? false
      : true;

  const tempCartProduct =
    tempItems.customize.items.filter((product) => product?.id == productObj?.id)?.length > 0;

  const tempCartProd =
    tempItems.customize.items.filter(
      (product) => product?.id == productObj?.id && !product?.notAdded
    )?.length > 0;

  let isCustomized =
    tempCartProd &&
    isProductCustomized(
      productObj,
      tempItems.customize.items.find((product) => product?.id == productObj?.id)
    );

  const itemExistsInCart = () => {
    let data = tempItems?.customize?.items?.find(
      (item) => item.id == (mainProductId || productObj.id)
    );

    return (
      !!data && (!!data['items'] || !!data['bundle'] || !!data['subItem']) && data?.isCustomized
    );
  };

  const handleRoute = (e) => {
    e.preventDefault();

    window.localStorage.setItem('notShowBogoPopup', true);

    const customizedProducts = tempItems?.customize?.items.filter(
      (item) => item.id == productObj.id
    );

    let mainProductObj = productsMap[mainProductId || productObj?.id];

    if (!isCustomized && customizedProducts.length == 0 && !locationSearch.has('cartId')) {
      dispatch(
        addProductToCustomize({
          productType: productObj.bundleTypeId,
          updatedOn: new Date().getTime(),
          mainProductId: productObj.id,
          data: {
            ...productObj,
            noIncrement: true,
          },
        })
      );
    } else if (tempCartProduct) {
      // add default items if notAdded: true
      let customization = JSON.parse(JSON.stringify(customizedProducts[0]));
      if (customization?.notAdded && !customization?.items) {
        let defaultItems = {},
          variationArray = [-1, -1, -1],
          currentProductVariation = null;

        Object.values(customization?.variants || {}).forEach((variation, idx) => {
          variationArray[idx] = variation;
        });

        currentProductVariation = productObj?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          let isVariantSame = true;
          variationArray.forEach((variant, index) => {
            if (itemInfo[`sel${index + 1}Value`] != variant) {
              isVariantSame = false;
            }
          });
          return isVariantSame;
        });

        if (!currentProductVariation?.id) {
          currentProductVariation = productsMap[currentProductVariation];
        }

        for (let step of currentProductVariation?.steps || []) {
          let optionObj = {};
          for (let option of step?.options || []) {
            if (option?.subOptions) {
              let defaultSubOption = option?.subOptions?.find(
                (subOption) => subOption?.default == 1
              );
              if (defaultSubOption) {
                optionObj[option.id] = { qty: 1 };
              }
            } else {
              if (option?.default) {
                optionObj[option.id] = { qty: 1 };
              }
            }
          }
          if (Object.values(optionObj || {}).length > 0) {
            defaultItems[step.id] = optionObj;
          }
        }

        customization['items'] = defaultItems;
      }

      dispatch(
        addPayloadToTempData({
          id: customization?.id,
          data: { ...customization },
        })
      );
    }

    if (isCustomized) {
      console.log(`4 setting unlockedStepperId to `, Number.MAX_SAFE_INTEGER);
      window.localStorage.setItem('unlockedStepperId', Number.MAX_SAFE_INTEGER);
    }

    let state = {
      state: {
        retUrl: returnURL,
      },
    };

    if (oldLocation) {
      state['state']['oldLocation'] = oldLocation;
      state['state']['oldLocation']['retUrl'] = oldLocation.pathname;
      if (!state['state']['oldLocation']['state']) {
        state['state']['oldLocation']['state'] = {};
      }
      state['state']['oldLocation']['state']['retUrl'] = oldLocation.pathname;
      state['state']['description'] = name;
    }

    if (
      !location.pathname?.includes('deals') &&
      !(location.pathname?.includes('search') && productObj['bundleTypeId'].includes('bundle'))
    ) {
      state = {
        state: {
          oldLocation: location,
          description: `${name}`,
          retUrl: returnURL,
        },
      };
    }

    console.log(`going to - `, productRoute);

    navigate(productRoute, state);
  };

  const handleHomePageItem = () => {
    dispatch(
      fetchProductsByCategoryId({
        cluster: clusterId,
        categoryId: productObj?.categories[0],
        Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
      })
    ).then((p) => {
      dispatch(
        getProductInfo({
          id: productObj?.id,
          cluster: clusterId,
          service: defaultAddress?.addressSubType || 'DELIVERY',
          categoryId: productObj?.categories[0],
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then((resp) => {
        let productData;
        if (resp?.payload?.id) {
          dispatch(addNewProduct(resp.payload));
          productData = resp.payload;
        } else {
          productData = productObj;
        }
        let category = {};
        let locale = intl.locale;
        let productRoute = '';
        category = categoryList.entities[productData?.categories?.[0]];
        productRoute = generateProductRoute({ product: productData, category, locale });

        if (
          (productData?.bundleTypeId === 'bundle' ||
            productData?.bundleTypeId === 'bundle_group') &&
          productData?.typeId != 'simple'
        ) {
          productRoute = `${productRoute}/bundle`;
        }
        dispatch(
          addProductToCustomize({
            productType: productData?.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: productData?.id,
            data: {
              ...productData,
              noIncrement: true,
            },
          })
        );
        navigate(productRoute, {
          state: {
            retUrl: `/${intl.locale}/home/`,
            oldLocation: location,
            description: `${productObj?.name || productObj?.title || ''}`,
          },
        });
      });
    });
  };

  const buildCatNavigate = (e) => {
    if (buildCat) {
      handleRoute(e);
    } else if (productObj?.isHomePageItem) {
      handleHomePageItem();
    }
  };

  const handleNavigation = () => {
    if (goToCustomize) {
      alert('Hi 2');
      navigate(productRoute, {
        state: {
          oldLocation: JSON.parse(JSON.stringify(location)),
          description: intl.formatMessage({ id: 'customize_your_meals' }),
        },
      });
    }
  };
  return (
    <div className={css.thumbnail} onClick={buildCatNavigate}>
      <LazyLoadImage
        onClick={handleNavigation}
        src={src}
        alt={productName}
        width="80"
        className={css.image}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImg;
        }}
      />
      {isPreviouslyOrdered && (
        <div className={css.previousOrderTag}>
          <div className={css.mainBackground}>
            <div className={css.textContent}>
              <FormattedMessage id="previouslyOrdered" defaultMessage="Previously Ordered" />
            </div>
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
